import React from "react";
import { Coins, Lock } from "lucide-react";
import { useTokens } from "./TokenContext";
import { useT } from "../context/LanguageContext";

export default function TokenWidget() {
  const { t } = useT();
  const { balance, progress_pct, next_token_at, total_points, points_per_token, loading } = useTokens();

  return (
    <div
      data-testid="v2-token-widget"
      className="relative overflow-hidden rounded-2xl border border-[#F59E0B]/30 bg-gradient-to-br from-[#1A1408] via-[#0E0902] to-[#0A0A0F] p-3.5 shadow-lg shadow-[#F59E0B]/10"
    >
      <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full bg-[#F59E0B]/15 blur-2xl pointer-events-none" />
      <div className="relative flex items-center gap-3">
        <div className="w-11 h-11 rounded-full flex items-center justify-center bg-gradient-to-br from-[#FFD700] via-[#F59E0B] to-[#B45309] shadow-inner shadow-[#FCD34D]/40 ring-1 ring-[#FCD34D]/30">
          <Coins className="w-5 h-5 text-[#3B2503]" strokeWidth={2.5} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline gap-1.5">
            <span className="text-[10px] font-mono uppercase tracking-[0.25em] text-[#FCD34D]/80">{t("v2.tok.balance")}</span>
            <span className="text-[9px] font-mono uppercase tracking-[0.2em] text-[#71717A]">/{points_per_token} {t("v2.tok.pts")}</span>
          </div>
          <div className="flex items-baseline gap-1.5">
            <span data-testid="v2-token-balance" className="text-2xl font-bold text-[#FCD34D] tabular-nums">{loading ? "—" : balance}</span>
            <span className="text-[10px] uppercase tracking-wider text-[#A1A1AA] font-bold">{t("v2.tok.tokens")}</span>
          </div>
          <div className="mt-1.5 flex items-center gap-2">
            <div className="flex-1 h-1 bg-[#27272F] rounded-full overflow-hidden">
              <div
                data-testid="v2-token-progress"
                className="h-full bg-gradient-to-r from-[#F59E0B] to-[#FCD34D] transition-all duration-500"
                style={{ width: `${Math.min(100, progress_pct)}%` }}
              />
            </div>
            <span className="text-[9px] font-mono uppercase tracking-[0.15em] text-[#71717A]">{total_points}/{next_token_at}</span>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center text-[#52525B]" title={t("v2.tok.unlock")}>
          <Lock className="w-3 h-3" />
          <span className="text-[8px] font-mono uppercase tracking-wider mt-0.5">{t("v2.tok.soon")}</span>
        </div>
      </div>
    </div>
  );
}
